import React from "react";

const BookAnAppointmentBar = ({
  title,
  subTitle,
  description,
  buttonText,
  buttonLink = "https://drmohansdiabetes.co.in/enroll/?campname=website",
}) => {
  return (
    <section className="overflow-hidden bg-primary py-12">
      <div className="container mx-auto">
        <div className=" flex flex-col items-center justify-center rounded-2xl py-8 text-white lg:flex-row">
          <div className="px-4 lg:w-6/12 lg:basis-6/12">
            <h3 className="mb-6 text-center font-canossa text-3xl font-bold text-white lg:text-left lg:text-5xl">
              <span className="font-normal">{title}</span>
              <br className="" />
              {subTitle}
            </h3>
            {description ? (
              <p className="pb-6 text-center font-futuraLt text-2xl text-base font-bold lg:pb-0 lg:text-left">
                {description}
              </p>
            ) : null}
          </div>
          <div className="relative mt-4 flex justify-center px-4 md:w-5/12 md:basis-5/12 lg:mt-0 lg:w-6/12 lg:basis-6/12 lg:justify-end">
            {buttonText ? (
              <a
                href={buttonLink}
                target="_blank"
                rel="noreferrer"
                className="cursor-pointer rounded-lg border border-white bg-white px-6 py-3 font-futuraMd text-base uppercase text-primary transition-all duration-500 hover:bg-white hover:text-secondary lg:px-20 lg:py-6 2xl:text-lg"
              >
                {buttonText}
              </a>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookAnAppointmentBar;
